import React, { Component } from "react";
import { Link } from "react-router-dom";

class NewsList_Content extends Component {
  render() {
    const { newsList } = this.props;

    return newsList ? (
      <div id="site-content" className="site-content clearfix">
        <div id="inner-content" className="inner-content-wrap">
          {newsList.map((data) => (
            <article className={data.aritcles} key={data.id}>
              <div className={data.classnames} style={{ maxHeight: "400px" }}>
                <Link
                  onClick={() => {
                    window.location.href = `/admin/news-edit?ID=${data.id}`;
                  }}
                  to={`/admin/news-edit?ID=${data.id}`}
                >
                  <img src={data.srcimg} alt="{data.title}" />
                </Link>
                <div className="post-calendar">
                  <span className="inner">
                    <span
                      className="entry-calendar"
                      style={{ background: "silver" }}
                    >
                      <span className="day">{data.day}</span>
                      <span
                        className="month"
                        style={{ textTransform: "uppercase" }}
                      >
                        {data.month}
                      </span>
                    </span>
                  </span>
                </div>
                <div className="overlay-effect bg-color-1" />
                <div className="elm-link">
                  <Link
                    onClick={() => {
                      window.location.href = `/admin/news-edit?ID=${data.id}`;
                    }}
                    to={`/admin/news-edit?ID=${data.id}`}
                    className="icon-1"
                  />
                </div>
              </div>
              <div className="post-content-wrap clearfix">
                <h2 className="post-title">
                  <span className="post-title-inner">
                    <Link
                      onClick={() => {
                        window.location.href = `/admin/news-edit?ID=${data.id}`;
                      }}
                      to={`/admin/news-edit?ID=${data.id}`}
                    >
                      {data.title}
                    </Link>
                  </span>
                </h2>
                <div className="post-meta">
                  <div className="post-meta-content">
                    <div className="post-meta-content-inner">
                      <span className="post-date item">
                        <span className="inner">
                          <span className="entry-date">{data.date}</span>
                        </span>
                      </span>
                      <span className="post-by-author item">
                        <span className="inner">
                          <Link to="#">
                            By:
                            {data.author}
                          </Link>
                        </span>
                      </span>
                      <span className="comment item">
                        <span className="inner">
                          <Link to="#">{data.comments} Comments</Link>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="post-content post-excerpt">
                  <p>{data.shortContent}</p>
                </div>
                <div className="post-read-more">
                  <div className="post-link">
                    <Link to={`/admin/news-edit?ID=${data.id}`}>EDIT</Link>
                  </div>
                </div>
              </div>
            </article>
          ))}
          <div className="themesflat-pagination clearfix">
            <ul>
              <li>
                <Link to="#" className="page-numbers prev">
                  <span className="fa fa-angle-left" />
                </Link>
              </li>
              <li>
                <Link to="#" className="page-numbers current">
                  1
                </Link>
              </li>
              <li>
                <Link to="#" className="page-numbers">
                  2
                </Link>
              </li>
              <li>
                <Link to="#" className="page-numbers next">
                  <span className="fa fa-angle-right" />
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div
          className="themesflat-spacer clearfix"
          data-desktop={80}
          data-mobile={60}
          data-smobile={60}
        />
      </div>
    ) : (
      <div />
    );
  }
}

export default NewsList_Content;
